import {FEATURE_FLAG_UA, FS_VIEW} from '../../common/constants';

import {HeaderLink} from './types';

function createHeaders(
  extraFlags: Record<string, boolean>,
  headerContent?: Record<string, string>,
  features?: Record<string, Set<string>>,
  menuItems?: HeaderLink[]
) {
  // Here index is starting with 2 because of home should be first
  const headers = {
    headerUserMgmt: {
      label: headerContent?.['userMgmtLbl'],
      URL: '/user-management',
      statusKey: FEATURE_FLAG_UA.USER_MGMT,
      index: 2
    },
    headerRemittance: {
      label: headerContent?.['remittanceSummaryLbl'] ?? '',
      URL: '/remittance-summary',
      statusKey: FEATURE_FLAG_UA.REMITTANCE,
      index: 3
    },
    headerDocMgmt: {
      label: headerContent?.['docMgmtLbl'],
      URL: '/doc-management',
      statusKey: FEATURE_FLAG_UA.DOC_MGMT,
      index: 4
    }
  };
  let headerData: HeaderLink[] = [];
  const defaultHeader = ((menuItems || [])?.filter((item) => item?.defaultHeader) || []).map((item) => {
    return {...item, isAccess: true};
  });
  Object.values(headers).forEach((header) => {
    const isFeatureEnabled = features?.[header.statusKey]?.has(FS_VIEW);
    const isExtraFlagSet = extraFlags?.[header.statusKey] ?? true;
    const findHeader = menuItems?.find((item) => item.url === header.URL);
    if (findHeader) {
      headerData.push({
        ...findHeader,
        isAccess: isFeatureEnabled && isExtraFlagSet
      });
    }
  });

  headerData = [...headerData, ...defaultHeader];
  headerData.sort((a, b) => (a.index ?? 0) - (b.index ?? 0));
  return {headerData};
}

export function calculateHeaderList(lookupData: any, headerListData: HeaderLink[], payeeId?: string) {
  const features: Record<string, Set<string>> = {};
  Object.values(lookupData as Record<string, string[]>).forEach((array: string[]) => {
    array.forEach((item: string) => {
      const [key, value] = item.split(':');
      if (key) {
        if (!features[key]) {
          features[key] = new Set();
        }
        features[key]?.add(value ?? '');
      }
    });
  });
  const extraFlags = {
    [FEATURE_FLAG_UA.REMITTANCE]: !!payeeId
  };

  const headerTabs: Record<string, string> = {};
  headerListData.forEach((item: HeaderLink) => {
    if (item?.id) {
      headerTabs[item.id] = item.label;
    }
  });
  const {headerData} = createHeaders(extraFlags, headerTabs, features, headerListData);
  return {headerData};
}
